jQuery.feature_import("js-view-labeling-queue-list",
  () => import("./edit.js"),
  mod => mod.feature_js_view_labeling_queue_list
);